/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconYna8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconYna8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 9 8" ref={ref}>
            <path
                d="M3.08 1.73a1.52 1.52 0 1 0-3.039 0 1.52 1.52 0 0 0 3.038 0ZM5.745 1.888a2.256 2.256 0 1 1 0 4.512 2.256 2.256 0 0 1 0-4.512ZM2.055 5.82a.92.92 0 1 1 0 1.842.92.92 0 0 1 0-1.842Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconYna12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconYna12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 13 12" ref={ref}>
            <path
                d="M4.62 2.594a2.279 2.279 0 1 0-4.558 0 2.279 2.279 0 0 0 4.558 0ZM8.619 2.832a3.384 3.384 0 1 1 0 6.767 3.384 3.384 0 0 1 0-6.767ZM3.083 8.73a1.381 1.381 0 1 1 0 2.763 1.381 1.381 0 0 1 0-2.762Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconYna16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconYna16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 17 16" ref={ref}>
            <path
                d="M6.159 3.458a3.038 3.038 0 1 0-6.077 0 3.038 3.038 0 0 0 6.077 0ZM11.49 3.775a4.512 4.512 0 1 1 0 9.024 4.512 4.512 0 0 1 0-9.024ZM4.11 11.64a1.842 1.842 0 1 1 0 3.683 1.842 1.842 0 0 1 0-3.683Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconYna24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconYna24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 25 24" ref={ref}>
            <path
                d="M9.24 5.187a4.558 4.558 0 1 0-9.115 0 4.558 4.558 0 0 0 9.115 0ZM17.238 5.663a6.767 6.767 0 1 1 0 13.535 6.767 6.767 0 0 1 0-13.535ZM6.166 17.46a2.762 2.762 0 1 1 0 5.525 2.762 2.762 0 0 1 0-5.524Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconYna32 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconYna32(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 33 32" ref={ref}>
            <path
                d="M12.32 6.916a6.077 6.077 0 1 0-12.154 0 6.077 6.077 0 0 0 12.154 0ZM22.983 7.551a9.023 9.023 0 1 1 0 18.047 9.023 9.023 0 0 1 0-18.047ZM8.221 23.281a3.683 3.683 0 1 1 0 7.366 3.683 3.683 0 0 1 0-7.366Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconYna48 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconYna48(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 49 48" ref={ref}>
            <path
                d="M18.479 10.374a9.115 9.115 0 1 0-18.231 0 9.115 9.115 0 0 0 18.23 0ZM34.473 11.326c7.475 0 13.535 6.06 13.535 13.535 0 7.476-6.06 13.536-13.535 13.536-7.475 0-13.535-6.06-13.535-13.535 0-7.476 6.06-13.535 13.535-13.535ZM12.33 34.921a5.524 5.524 0 1 1 0 11.05 5.524 5.524 0 0 1 0-11.05Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconYna = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconYna(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconYna8 {...iconProps} />;
        case '12':
            return <IconYna12 {...iconProps} />;
        case '16':
            return <IconYna16 {...iconProps} />;
        case '24':
            return <IconYna24 {...iconProps} />;
        case '32':
            return <IconYna32 {...iconProps} />;
        case '48':
            return <IconYna48 {...iconProps} />;
        default:
            return <IconYna48 {...iconProps} />;
    }
});
